import { VariantOption } from 'src/state';

export interface ProductClass {
    id: number;
    variantOptionId: number;
    variantOption: VariantOption;
}
